import {observable, action, runInAction} from 'mobx';
import Api from '../../services/api';
import Pnotify from 'pnotify';

class EmailTemplatesStore {
    constructor() {
        this.getEmailTemplatesData();
    }

    @observable public emailTemplates:any[] = [];

    @action
    public getEmailTemplatesData = async () => {
        try {
            const emailTemplates = await Api.getEmailTemplates();
            runInAction(() => {
                this.emailTemplates = emailTemplates;
            });
        } catch(e) {
            console.log(e);
        }
    };

    @action
    public sendEmail = async (result: {}) => {
        try {
            await Api.sendEmail(result);

            new Pnotify({
                title: 'Send email',
                text: 'Email successfully sent',
                addclass: 'bg-success'
            })
        } catch(e){
            console.error(e);

            new Pnotify({
                title: 'Send email',
                text: 'Error occurred while sending message. Please try again.',
                addclass: 'bg-danger'
            })
        }
    }

}

const emailTemplatesStore = new EmailTemplatesStore();

export default emailTemplatesStore;
